import { render, staticRenderFns } from "./YourApplication.vue?vue&type=template&id=bbf5b2d2"
import script from "./YourApplication.vue?vue&type=script&lang=ts"
export * from "./YourApplication.vue?vue&type=script&lang=ts"
import style0 from "./YourApplication.vue?vue&type=style&index=0&id=bbf5b2d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports